import { call, put } from 'redux-saga/effects';
import {
  addOrganisationFailure,
  addOrganisationSuccess,
  clearPendingNavigateAfterCreate,
  fetchOrganisationsLightRequest,
} from '../actions';
import { addOrganisation } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';

import { checkResponse } from 'store/utils';
import { AddOrganisationRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { push } from 'store/navigation/actions';
import routes from 'routes';
import { Provider } from 'store/api/enums';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* addOrganisationSaga(action: AddOrganisationRequestAction) {
  try {
    let err: ApiError | null;
    const params = action.payload.addOrganisation;
    const addResponse: ApiResponse = yield call(addOrganisation, params);

    err = checkResponse(addResponse?.responseMessage);
    if (err) throw err;

    yield put(addOrganisationSuccess());

    const isExcelOrReceipts =
      params.providerName === Provider.EXCEL ||
      params.providerName === Provider.RECEIPTS;
    const data = addResponse?.data;
    const organisationId =
      data?.organisationId ??
      data?.connectionId ??
      data?.uuid ??
      data?.organisation?.uuid ??
      data?.organisation?.connectionId;

    if (isExcelOrReceipts && organisationId) {
      yield put(
        push(
          `${routes.organisations.organisation.replace(
            ':id',
            organisationId
          )}?tab=capture`
        )
      );
      yield put(clearPendingNavigateAfterCreate());
    }

    // Lightweight organisations refresh – avoids tax rates / excel metadata /
    // profile picture fan-out while still updating the list with the new entity.
    yield put(fetchOrganisationsLightRequest());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(addOrganisationFailure());
  }
}
